import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=5daf7e9e&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=5daf7e9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daf7e9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/.jenkins/workspace/crm-ui/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5daf7e9e')) {
      api.createRecord('5daf7e9e', component.options)
    } else {
      api.reload('5daf7e9e', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=5daf7e9e&scoped=true&", function () {
      api.rerender('5daf7e9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/customer/customerVisitRecord/edit.vue"
export default component.exports